module.exports = __webpack_public_path__ + "img/6.44dde7f4.svg";